import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface Props {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const MarginBonusStatusFilter: React.FC<Props> = ({ filter, onFilterChange }) => {
  const marginBonusStatuses = useAppSelector(
    (state) => state.tradingAccounts.marginBonusResultStatus
  )

  const data = marginBonusStatuses?.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
